import { GroupTableData } from '../types/GroupTableData';
import { TeamForm } from '../types/TeamForm';
import { apiGet } from './apiClient';

export function getLastUpdate(): Promise<string> {
  return apiGet<string>('/api/Score/LastUpdate');
}

export function getGroupTable(group: string): Promise<GroupTableData[]> {
  return apiGet<GroupTableData[]>(`/api/Score/TeamTable/${group}`);
}

// Recent W/D/L form for every team, loaded once and cached in TeamFormContext.
export function getAllTeamsForm(count = 5): Promise<TeamForm[]> {
  return apiGet<TeamForm[]>(`/api/Score/TeamForm?count=${count}`);
}

export interface BetExcelBlobFile {
  name: string;
  url: string;
  dateCreated: string;
}

export function getBetsExcelsList(): Promise<BetExcelBlobFile[]> {
  return apiGet<BetExcelBlobFile[]>('/api/Score/Bets/ExcelsList');
}
